<template>
  <div class="version-item">
    <div class="header" :class="{editing: item.editing}">
      <div class="time">{{toDatetimeStr(item.time)}}</div>
      <el-tooltip effect="dark" content="恢复" placement="bottom">
        <div class="btn btn-revert" @click="revert"></div>
      </el-tooltip>
    </div>
    <div class="content" v-if="!item.editing">
      <div class="view">{{item.comment}}</div>
    </div>
    <div class="footer" v-if="!item.editing">
      <div class="person">
        <div class="figure">
          <img :src="item.figure || 'https://resources.laihua.com/web/defaultAvanta.jpg'" alt />
        </div>
        <div class="name">{{item.name}}</div>
      </div>
      <div class="btns">
        <el-tooltip effect="dark" content="预览" placement="bottom">
          <div class="btn btn-preview" @click="preview"></div>
        </el-tooltip>

        <el-tooltip effect="dark" content="备注" placement="bottom">
          <div class="btn btn-edit" @click="openEditing"></div>
        </el-tooltip>

        <el-tooltip effect="dark" content="删除" placement="bottom">
          <div class="btn btn-remove" @click="remove"></div>
        </el-tooltip>
      </div>
    </div>

    <div class="editing" @keydown.stop v-show="item.editing">
      <!-- <textarea maxlength="200" autosize></textarea> -->
      <el-input
        type="textarea"
        autofocus
        :autosize="{ minRows: 2, maxRows: 60 }"
        placeholder="添加描述方便查看管理"
        v-model="item.comment"
        @blur="inputBlur"
        ref="input"
        :maxlength="200"
        show-word-limit
      ></el-input>
    </div>
  </div>
</template>

<script>
import Datetime from "@/plugins/Datetime";
export default {
  props: {
    item: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      editing: false,
    };
  },
  watch: {
    "item.editing"(val) {
      if (val) {
        this.$nextTick(() => {
          $(this.$el).find("textarea").focus();
        });
      }
    },
  },
  mounted() {
    $(this.$el).find("textarea").focus();
  },
  methods: {
    toDatetimeStr(date) {
      if (!date) {
        date = new Date();
      }
      return new Datetime(date).toDatetimeStr();
    },
    inputBlur(ev) {
      this.$emit("inputBlur", {
        ev,
        index: this.index,
        value: this.item.comment,
        itemId: (this.item.data || {}).id,
      });
    },
    openEditing() {
      this.$emit("openEditing", {
        index: this.index,
      });
      this.$nextTick(() => {
        $(this.$el).find("textarea").focus();
      });
    },
    revert() {
      this.$emit("revert", {
        index: this.index,
        item: this.item,
      });
    },
    remove() {
      this.$emit("remove", {
        index: this.index,
        item: this.item,
      });
    },
    preview() {
      this.$emit("preview", {
        index: this.index,
        item: this.item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.version-item {
  width: 226px;
  margin-bottom: 15px;
  & .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 226px;
    height: 32px;
    padding: 10px;
    background: #fafaff;
    border: 1px solid #d9ddea;
    border-radius: 4px 4px 0px 0px;
    font-size: 12px;
    box-sizing: border-box;

    & .btn-revert {
      background-image: url(../../../static/svg/versionControl/revert.svg);
      &:hover {
        background-image: url(../../../static/svg/versionControl/revert-active.svg);
      }
    }

    &.editing {
      border-color: #5778fb;
    }
  }

  & .content {
    padding: 10px;
    border-width: 0 1px 0 1px;
    border-color: #d9ddea;
    border-style: solid;
  }

  & .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 10px;
    border-width: 0 1px 1px 1px;
    border-color: #d9ddea;
    border-style: solid;
    border-radius: 0px 0px 4px 4px;
  }
}
.content {
  & .view {
    font-size: 12px;
    color: #474261;
    text-align: left;
    // white-space: pre;
    min-height: 1.2em;
    word-break: break-word;
  }
}
.person {
  display: flex;
  align-items: center;
  justify-content: center;
  & .figure {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 6px;
    overflow: hidden;
  }
  & .name {
    font-size: 12px;
    color: #9692a9;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  & .btn-preview {
    margin-right: 6px;
    background-image: url(../../../static/svg/versionControl/eye.svg);
    &:hover {
      background-image: url(../../../static/svg/versionControl/eye-active.svg);
    }
  }
  & .btn-edit {
    margin-right: 6px;
    background-image: url(../../../static/svg/versionControl/edit.svg);
    &:hover {
      background-image: url(../../../static/svg/versionControl/edit-active.svg);
    }
  }
  & .btn-remove {
    background-image: url(../../../static/svg/versionControl/remove.svg);
    &:hover {
      background-image: url(../../../static/svg/versionControl/remove-active.svg);
    }
  }
}
.btn {
  display: none;
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.version-item:hover .btn {
  display: block;
}
.editing {
  padding: 0;
  border-width: 0 1px 1px 1px;
  border-color: #5778fb;
  border-style: solid;
  font-size: 12px;
  text-align: left;
  border-radius: 0 0 4px 4px;
  & > textarea {
    border-width: 0;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/versionControl/item.vue